<template>
  <div style="background: #fefbfb">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      :is-full-page="fullPage"
      :height="height"
      :width="width"
      background-color="#6b6969"
    />
    <TopNavbar />
    <section class="container-fluid job-fair-text" style="padding-top: 7rem">
      <div class="row">
        <div class="col-md-7">
          <h1 class="font-weight-bold heading-title">
            About the Startup <br />
            Coach School
          </h1>
          <div
            class="divider bg-orange"
            style="width: 228px; height: 10px; border-radius: 0"
          ></div>
          <div class="row mt-4">
            <div class="col-md-9">
              <p>
                The Startup Coach School is an initiative of Ghana Tech Lab in
                collaboration with
                <span class="text-orange">Innohub Ghana.</span>
              </p>
              <p>
                Our objective is to create structures as an institution to
                standardise the educational training and capacities of Business
                Developers to provide high quality services and support the
                growth of startups across the regional ecosystems in Ghana.
              </p>
              <p>
                Training is delivered in modules, with each level focusing on a
                specialization of the business development/growth process.
              </p>
              <p>
                You will receive a certification after completing each level of
                the Coach school and passing examinations at each level.
              </p>
              <p class="font-weight-bold" style="font-family: 'gothamMedium'">
                A grand certification and graduation is awarded to participants
                who complete at least 3 of the modules.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <img src="@/assets/side-bg.png" alt="" class="img-fluid" />
        </div>
      </div>
    </section>

    <!-- Job section -->
    <div style="background: #f2feff">
      <div class="container-fluid job-fair-text">
        <div class="row pt-5 pb-5">
          <div class="col-md-12 text-center">
            <h2 class="heading-title">Why Join Our School?</h2>
            <div
              class="divider bg-orange"
              style="
                width: 228px;
                height: 10px;
                border-radius: 0;
                margin: 0 auto;
              "
            ></div>
            <p class="mt-5 mb-5 text-center" style="color: #727272">
              Get certified as a Startup Coach. We designed this program with
              you in mind. <br />
              Here are ways you will benefit from our coach school:
            </p>
          </div>
          <div class="col-md-4">
            <div class="row no-gutters">
              <div class="col-4 col-md-2">
                <img
                  src="@/assets/why_img_1.png"
                  class="card-img img-fluid"
                  alt="why_1"
                  style="width: 80px; height: 80px"
                />
              </div>
              <div class="col-8 col-md-10">
                <p class="font-weight-bold mt-3 mt-md-4">
                  Trainings are hybrid , online and on-site
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row no-gutters">
              <div class="col-4 col-md-2">
                <img
                  src="@/assets/why_img_2.png"
                  class="card-img img-fluid"
                  alt="why_1"
                  style="width: 80px; height: 80px"
                />
              </div>
              <div class="col-8 col-md-10">
                <p class="font-weight-bold mt-3 mt-md-4">
                  Progress through each module with certification
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row no-gutters">
              <div class="col-4 col-md-2">
                <img
                  src="@/assets/why_img_3.png"
                  class="card-img img-fluid"
                  alt="why_1"
                  style="width: 80px; height: 80px"
                />
              </div>
              <div class="col-8 col-md-10">
                <p class="font-weight-bold mt-3 mt-md-4">
                  Sign up and payment process made easy
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid job-fair-text">
      <div class="row pt-5 pb-5">
        <div class="col-md-12 text-center">
          <h2 class="heading-title">How It Works</h2>
          <div
            class="divider bg-orange"
            style="width: 150px; height: 10px; border-radius: 0; margin: 0 auto"
          ></div>
          <p class="mt-5 mb-5 text-center" style="color: #727272">
            Our process is seamless and flexible. Join us today using the
            following steps:
          </p>
        </div>
        <div class="col-md-12">
          <img
            src="@/assets/how_it_work.png"
            class="card-img img-fluid"
            alt="how it works"
          />
        </div>
        <div class="col-md-12">
          <p class="text-center">
            *Apply for our scholarships and receive between 50% to 100%
            discount. Women and persons with disability <br />
            stand a chance of receiving 70% discount on the training. Our
            scholarships cover the cost of training, <br />
            training materials, examination and certification costs.
          </p>
        </div>
      </div>
    </div>

    <div class="container-fluid job-fair-text">
      <div class="row pt-5 pb-5">
        <div class="col-md-12 text-center">
          <h2 class="heading-title">Certificates & Grading</h2>
          <div
            class="divider bg-orange"
            style="width: 150px; height: 10px; border-radius: 0; margin: 0 auto"
          ></div>
          <p class="mt-5 mb-5 text-center" style="color: #727272">
            After receiving training in each Module, each student receives a
            certificate. <br />
            The star grading on each certificate is however a cumulative average
            of the score of a student as at the particular Module taken.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <img
                  src="@/assets/platinum.png"
                  alt=""
                  class="card-img img-fluid"
                  style="
                    width: 35px;
                    height: 70px;
                    position: absolute;
                    right: 2rem;
                  "
                />
                <div class="card-body">
                  <div>Platinum</div>
                  <p class="text-center mt-5 mb-5">
                    Coaches that have attained a score of 99-100% are <br />
                    awarded a Platinum Certificate.
                  </p>
                  <h3>100-99</h3>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <img
                  src="@/assets/gold.png"
                  alt=""
                  class="card-img img-fluid"
                  style="
                    width: 35px;
                    height: 70px;
                    position: absolute;
                    right: 2rem;
                  "
                />
                <div class="card-body">
                  <div>Platinum</div>
                  <p class="text-center mt-5 mb-5">
                    Coaches that have attained a score of 98-100% are <br />
                    awarded a Gold Certificate.
                  </p>
                  <h3>98-90</h3>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <img
                  src="@/assets/silver.png"
                  alt=""
                  class="card-img img-fluid"
                  style="
                    width: 35px;
                    height: 70px;
                    position: absolute;
                    right: 2rem;
                  "
                />
                <div class="card-body">
                  <div>Silver</div>
                  <p class="text-center mt-5 mb-5">
                    Coaches that have attained a score of 89-80% are <br />
                    awarded a Silver Certificate.
                  </p>
                  <h3>89-80</h3>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <img
                  src="@/assets/bronze.png"
                  alt=""
                  class="card-img img-fluid"
                  style="
                    width: 35px;
                    height: 70px;
                    position: absolute;
                    right: 2rem;
                  "
                />
                <div class="card-body">
                  <div>Bronze</div>
                  <p class="text-center mt-5 mb-5">
                    Coaches that have attained a score of 79-70% are
                    <br />awarded a Bronze Certificate.
                  </p>
                  <h3>79-70</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="join-coach">
      <div class="container-fluid job-fair-text">
        <div class="row pt-5 pb-5">
          <div class="col-md-12 text-center">
            <h2 class="heading-title">
              JOIN THE STARTUP COACH <br />
              SCHOOL COMMUNITY
            </h2>
            <button class="btn btn-orange pl-3 pr-3">Become a Coach</button>
          </div>
        </div>
      </div>
    </div>

    <div style="background: #f2feff">
      <div class="container-fluid job-fair-text">
        <div class="row pt-5 pb-5">
          <div class="col-md-12 text-center">
            <h2 class="heading-title">Frequently Asked Questions (FAQs)</h2>
            <div
              class="divider bg-orange"
              style="
                width: 228px;
                height: 10px;
                border-radius: 0;
                margin: 0 auto;
              "
            ></div>
          </div>
          <div class="col-md-12">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-body">
                  <div
                    class="mb-0 text-green accordion-button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Who qualifies to join the Startup Coach School
                  </div>
                </div>

                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Any individual with an interest to carve a career path in
                    business development for startups and/or SMEs.
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div
                    class="mb-0 text-green accordion-button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-controls="collapseTwo"
                  >
                    How many startups can I coach at a time?
                  </div>
                </div>

                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-body">
                  <div
                    class="mb-0 text-green accordion-button"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-controls="collapseThree"
                  >
                    Is this volunteer work or it’s a paid position?
                  </div>
                </div>

                <div
                  id="collapseThree"
                  class="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-body">
                  <div
                    class="mb-0 text-green accordion-button"
                    data-toggle="collapse"
                    data-target="#collapseFive"
                    aria-controls="collapseFive"
                  >
                    How do I become a part of the coach portal?
                  </div>
                </div>

                <div
                  id="collapseFive"
                  class="collapse"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                    sunt aliqua put a bird on it squid single-origin coffee
                    nulla assumenda shoreditch et. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                    Leggings occaecat craft beer farm-to-table, raw denim
                    aesthetic synth nesciunt you probably haven't heard of them
                    accusamus labore sustainable VHS.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <bottomFooter />
  </div>
</template>

<script>
/* eslint-disable */

// import Footer from "../components/Footer";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import moment from "moment";
import $ from "jquery";

export default {
  name: "Jobs",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      height: 128,
      width: 128
    };
  },
  components: {
    TopNavbar: () => import("@/components/TalentNav"),
    Loading,
    bottomFooter: () => import("@/components/Footer")
  },
  methods: {},
  created() {
    document.title = "About || Start Up Coach School";
  }
};
</script>

<style src="../../../public/assets/css/general-front-css.css" scoped />

<style scoped>
.join-coach {
  background-image: url("../../assets/patterns.png");
  background-size: cover;
}
.accordion-button {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  /* padding: 1rem 1.25rem; */
  font-size: 1rem;
  color: #212529;
  text-align: left;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    border-radius 0.15s ease;
}

.accordion-button[aria-expanded="true"]::after {
  font-family: FontAwesome;
  content: "\f068";
  color: #fd7e14;
  /* background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z' clip-rule='evenodd'/%3e%3c/svg%3e"); */
  transform: rotate(-180deg);
}
.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  /* content: ""; */
  font-family: FontAwesome;
  content: "\f067";
  color: black;
  /* background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z' clip-rule='evenodd'/%3e%3c/svg%3e"); */
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}

/* navbar styling */
label {
  color: #131212;
}

.nav-item a {
  color: white;
  font-family: var(--gotham);
  font-size: 1.1em;
}

/* header */
header {
  height: 60vh;
  /*background: url('../../assets/events/events-bg.png');*/
  width: 100%;
}

.text h1 {
  font-size: 3.125em;
  font-family: var(--gothamBold);
  margin-bottom: 1.5rem;
}

.text p {
  margin-bottom: 1.5rem;
}

/* job fair section*/

.heading h2 {
  font-size: 1.875em;
  font-family: var(--gothamBold);
  margin-bottom: 0;
  color: white;
  text-align: center;
}

.job-fair-text {
  width: 90%;
  /*margin-top: -3rem;*/
  border-radius: 10px;
  padding: 1rem 3rem;
  text-align: left !important;
}

/* upcoming events */

.card {
  color: black;
  margin: 1rem 0;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 599px) and (min-width: 300px) {
  .job-fair-text {
    padding: 0;
  }
}
</style>
